/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { TasksApiConfiguration as __Configuration } from '../tasks-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultTaskTemplateInfo } from '../models/list-query-result-task-template-info';
import { CreateTaskTemplateCommand } from '../models/create-task-template-command';
import { UpdateTaskTemplateCommand } from '../models/update-task-template-command';
import { ModelQueryResultTaskTemplateDetailsInfo } from '../models/model-query-result-task-template-details-info';
import {CreateTemplateCommand} from '../models/create-template-command';
@Injectable({
  providedIn: 'root',
})
class TaskTemplateService extends __BaseService {
  static readonly GetAllPath = '/api/tasks/templates';
  static readonly CreateTemplatePath = '/api/tasks/templates';
  static readonly GetUpdateTemplatePath = '/api/tasks/templates/{id}/update';
  static readonly UpdateTemplatePath = '/api/tasks/templates/{id}/update';
  static readonly GetTemplateDetailsPath = '/api/tasks/templates/{id}';
  static readonly DeleteTemplatePath = '/api/tasks/templates/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `TaskTemplateService.GetAllParams` containing the following parameters:
   *
   * - `taskTypes`:
   *
   * - `taskGroups`:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAllResponse(params: TaskTemplateService.GetAllParams): __Observable<__StrictHttpResponse<ListQueryResultTaskTemplateInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.taskTypes || []).forEach(val => {if (val != null) __params = __params.append('taskTypes', val.toString())});
    (params.taskGroups || []).forEach(val => {if (val != null) __params = __params.append('taskGroups', val.toString())});
    (params.sortFields || []).forEach(val => {if (val != null) __params = __params.append('sortFields', val.toString())});
    (params.sortCriteria || []).forEach(val => {if (val != null) __params = __params.append('sortCriteria', val.toString())});
    if (params.pattern != null) __params = __params.set('pattern', params.pattern.toString());
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null) __params = __params.set('pageNumber', params.pageNumber.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/templates`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultTaskTemplateInfo>;
      })
    );
  }
  /**
   * @param params The `TaskTemplateService.GetAllParams` containing the following parameters:
   *
   * - `taskTypes`:
   *
   * - `taskGroups`:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAll(params: TaskTemplateService.GetAllParams): __Observable<ListQueryResultTaskTemplateInfo> {
    return this.GetAllResponse(params).pipe(
      __map(_r => _r.body as ListQueryResultTaskTemplateInfo)
    );
  }

  /**
   * @param command undefined
   */
  CreateTemplateResponse(command?: CreateTaskTemplateCommand): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/tasks/templates`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param command undefined
   */
  CreateTemplate(command?: CreateTaskTemplateCommand): __Observable<null> {
    return this.CreateTemplateResponse(command).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateTemplateResponse(id: string): __Observable<__StrictHttpResponse<UpdateTaskTemplateCommand>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/templates/${id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UpdateTaskTemplateCommand>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateTemplate(id: string): __Observable<UpdateTaskTemplateCommand> {
    return this.GetUpdateTemplateResponse(id).pipe(
      __map(_r => _r.body as UpdateTaskTemplateCommand)
    );
  }

  /**
   * @param params The `TaskTemplateService.UpdateTemplateParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateTemplateResponse(params: TaskTemplateService.UpdateTemplateParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.command;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/tasks/templates/${params.id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `TaskTemplateService.UpdateTemplateParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateTemplate(params: TaskTemplateService.UpdateTemplateParams): __Observable<null> {
    return this.UpdateTemplateResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetTemplateDetailsResponse(id: string): __Observable<__StrictHttpResponse<ModelQueryResultTaskTemplateDetailsInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/tasks/templates/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ModelQueryResultTaskTemplateDetailsInfo>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  GetTemplateDetails(id: string): __Observable<ModelQueryResultTaskTemplateDetailsInfo> {
    return this.GetTemplateDetailsResponse(id).pipe(
      __map(_r => _r.body as ModelQueryResultTaskTemplateDetailsInfo)
    );
  }

  /**
   * @param id undefined
   */
  DeleteTemplateResponse(id: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/tasks/templates/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DeleteTemplate(id: string): __Observable<null> {
    return this.DeleteTemplateResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }

  CreateTaskTemplate(params: CreateTemplateCommand): __Observable<any> {
    return this.http.post<any>(this.rootUrl + `/api/tasks/templates/create-task-template`, params);
  }
}

module TaskTemplateService {

  /**
   * Parameters for GetAll
   */
  export interface GetAllParams {
    taskTypes?: Array<string>;
    taskGroups?: Array<string>;
    sortFields?: Array<any>;
    sortCriteria?: Array<any>;
    pattern?: string;
    pageSize?: number;
    pageNumber?: number;
  }

  /**
   * Parameters for UpdateTemplate
   */
  export interface UpdateTemplateParams {
    id: string;
    command?: UpdateTaskTemplateCommand;
  }
}

export { TaskTemplateService }
